import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=112d45d1&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "grapesjs/dist/css/grapes.min.css?vue&type=style&index=0&id=112d45d1&scoped=true&lang=css&"
import style1 from "./Page.vue?vue&type=style&index=1&id=112d45d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112d45d1",
  null
  
)

export default component.exports